var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnArrowPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25998 0.286698C6.64225 -0.0955659 7.26202 -0.0955659 7.64428 0.286698C8.02655 0.668961 8.02655 1.28873 7.64428 1.671L2.37127 6.94401L7.75627 12.329C8.13853 12.7113 8.13853 13.331 7.75627 13.7133C7.37401 14.0956 6.75424 14.0956 6.37197 13.7133L0.40163 7.74296C0.361425 7.71354 0.322958 7.68067 0.286635 7.64434C-0.0956278 7.26208 -0.0956287 6.64231 0.286635 6.26005L6.25998 0.286698Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnArrowPrev);
export default __webpack_public_path__ + "static/media/icn-arrow-prev.0de8f541.svg";
export { ForwardRef as ReactComponent };